module.exports = __webpack_public_path__ + "img/searchparking.1ec205af.png";